import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { UidContext } from "./AppContext";
import Logout from "./Log/Logout";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import Log from "../components/Log";
import ContactForm from "./contactForm";
import { CATEGORIES } from './categorie.constant';

Modal.setAppElement("#root");

const Header = () => {

  const uid = useContext(UidContext);
  const userData = useSelector((state) => state.userReducer);

  const [modalLogIsOpen, setModalLogIsOpen] = useState(false);
  const [ModalContactIsopen, setModalCOntactisOpen] = useState(false);

  const slogan1 = "Je dépose, je vends";
  const slogan2 = "Je trouve, j'achète";

  return (
    <header className="header">
      <div className="firstLignHeader flex justify-content-between">
        <NavLink exact to="/">
          <div className="logo">
            <img alt="undefined" src="/img/logo.png" />
          </div>
        </NavLink>
        <div className="navbar">
          {uid && userData.isAdmin && (
            <span>
              <NavLink exact to="/admin">
                <button className="navButton button">Admin</button>
              </NavLink>
            </span>
          )}
          <span>
            <NavLink exact to="/Annonces">
              <button className="navButton button">Trouver une annonce</button>
            </NavLink>
          </span>
          <span>
            <NavLink exact to="/CreationAnnonce">
              <button className="navButton button">Déposer une annonce</button>
            </NavLink>
          </span>
          {uid ? (
            <span className="userConnecte flex">
              <div className="flex">
                <Logout />
                <span className="text-connecte">
                  Connecté: {userData.pseudo}
                </span>
              </div>
            </span>
          ) : (
            <span className="userConnecte flex">
              <div>
                <img
                  onClick={() => setModalLogIsOpen(true)}
                  src="/img/logo_utilisateur.png"
                  alt="logo utilisateur"
                  title="Aucun utilisateur connecté"
                />
              </div>
            </span>
          )}
        </div>
      </div>
      <div className="secondLignHeader flex">
        {CATEGORIES.map((cat, index) => (
          <div key={index} className="flex item">
            {<span className="separatorSquare" />}
            <span>{cat.label}</span>
          </div>
        ))}
      </div>
      <div className="slogan">
        <p>
          <span>{slogan1}</span>
          <span> - </span>
          <span>{slogan2}</span>
        </p>
      </div>
      <div className="pub">
        <img src="/img/pub.png" alt="publicité" />
      </div>
      <div className="contactText">
        <span>Pour voir votre publicité sur ce site, cliquez </span>
        <span className="spanClick" onClick={() => setModalCOntactisOpen(true)}>
          ici
        </span>
      </div>
      <Modal
        isOpen={modalLogIsOpen}
        onRequestClose={() => setModalLogIsOpen(false)}
        style={customStyles}
      >
        <button onClick={() => setModalLogIsOpen(false)}>Fermer</button>
        <Log />
      </Modal>
      <Modal
        isOpen={ModalContactIsopen}
        onRequestClose={() => setModalCOntactisOpen(false)}
        style={customStylesContact}
      >
        <button onClick={() => setModalCOntactisOpen(false)}>Fermer</button>
        <ContactForm />
      </Modal>
    </header>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
  },
};
const customStylesContact = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
    backgroundColor: "$secondary-color",
  },
};

export default Header;
